import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=077b8734&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=077b8734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b8734",
  null
  
)

export default component.exports